module.exports = __webpack_public_path__ + "img/XENT-G.f7845e8d.png";